/***** User end points ******/
export const Login_USER_API = "/user/auth/login";
export const Login_OTP_VERIFY_API = "/user/auth/verify-otp";
export const VERIFY_SESSION_TOKEN_API = "/user/auth/verifysessiontoken";
export const DELETE_SESSION_TOKEN_API = "/user/auth/deletesessiontoken";
export const USER_UPDATE_PASSWORD = "/user/change-password/";
export const Set_USER_PASSWORD = "/user/auth/set-password";
export const ADD_USER = "/user/auth/register";
export const VERIFY_EMAIL = "/user/auth/forgot-password";
export const RESET_PASSWORD = "/user/auth/reset-password";
export const GET_PROFILE_DATA = "/user/";
export const PHONE_OTP_VERIFY = "/user/verify-phone/";
export const RESEND_OTP = "/user/auth/resend-otp";
export const GET_USER_ROLES = "/user/role";
export const CHECK_INVITATION_TOKEN = "/user/auth/check-invitation";
export const GET_COUNTRY_CODE = "/user/country-list";

/***** Customer end points ******/
export const ADD_CUSTOMER = "/customer/";
export const ADD_CUSTOMER_FORM = "/customer/form";
export const GET_DATA_FROM_ZIPCODE = "/customer/zip-details/";
export const ADD_CUSTOMER_USER = "/customer/customer-user/";
export const GET_PARENT_CUSTOMER_DATA = "/user/auth/parent-customer";
export const GET_CUSTOMER_LIST = "/user/auth/customerList";
export const SWITCH_PARENT_CUSTOMER = "/user/auth/switch-user";
export const CUSTOMER_MARKUP = "/customer/markup";
export const CUSTOMER_MARKUP_AGENT = "/customer/markup/agent-markup/";
export const CUSTOMER_MARKUP_SERVICES = "/customer/markup/service-markup/";
export const CUSTOMER_CHARGES_ADDITIONALS_DATA = "/customer/charges/additional";
export const REMOVE_CUSTOMER_ADDITIONAL_CHARGES = "/customer/charges/removeAdditionalCharges";
export const GET_CUSTOMER_NOTIFICATION = "/customer/notification/";
export const UPDATE_CUSTOMER_NOTIFICATION = "/customer/notification/";
export const GET_CUSTOMER_EMAIL_NOTIFICATION = "/customer/email-notification/";

/***** Agent end points ******/
export const ADD_EDIT_AGENT = "/agent/";
export const REMOVE_AGENT_ADDITIONAL_CHARGES = "/agent/charges/removeAdditionalCharges";
export const AGENT_FOR_CUSTOMER_RATE = "/agent/customer-rate-agents";
export const GET_AGENT_TYPE = "/agent/agent-type";
export const GET_AGENT_SERVICE_LIST = "/agent/service";
export const SERVICE_FOR_CUSTOMER_RATE = "/agent/service/customer-rate-services";
export const GET_AGENT_DETAILS = "/agent/agent-rate";
export const GET_FSC_LOCATIONS = "/agent/fsc-location";
export const AGENT_HUB_DATA = "/agent/agent-hub/";
export const AGENT_HUB_FIRST_BY_AGENT = "/agent/agent-hub/first-hub-by-agent";
export const AGENT_HUB_FOR_CUSTOMER_RATE = "/agent/agent-hub/customer-rate-hubs";
export const AGENT_HUB_SERVICE_ZIP = "/agent/agent-hub/service-zip";
export const AGENT_HUB_CUSTOMER = "/agent/agent-hub/customer";
/**
 * Final Mile agent catalog/mapping for a given internal LTL agent.
 * GET  ?internalLtlAgentId=<id> → { allActiveFinalmileAgent, allActiveMapFinalmileAgent }
 * POST → body { internalAgentId, activeFinalmileAgentId[], inactiveFinalmileAgentId[] }
 */
export const FINAL_MILE_AGENT_LIST_FOR_LTL_AGENT = "/agent/internal-ltl-final-mile-agent";
export const GET_AGENT_NUMBER = "/agent/agent-number/"; // trailing slash — agent id appended
export const ORDER_STATUS = "/order/order-status";
export const GET_OTHER_CHARGE_LIST = "/order/other-charge/list";
/** PUT — saves the Track LTL handles for one order. */
export const SAVE_ORDER_TRACK_LTL = "/order/save-track-ltl";
/** GET — checks whether a BOL is already on file before Track LTL saves it. Append `?bol=<value>`. */
export const CHECK_TRACK_LTL_BOL = "/order/trackltl/checkbol";

/*** Report end points *****/
export const GET_REPORT_COLUMNS = "/report/column-list";
export const GET_REPORT_URL = "/report/reporturl";
export const REPORT_CUSTOMER_LIST = "/report/customer/list";

/***** Dispatch board end points ******/
export const DISPATCH_BOARD_ADD_NOTE = "/order/dispatch-board/note";
export const GET_DISPATCH_ACCOUNT_EXCEPTIONS = "/order/accounting-exception/list";

/***** External end points ******/
export const GET_CUSTOMER_KEY = "/external/v1/credential";
export const GET_AGENT_KEY = "/external/v1/generateagentcred";
export const REMOVE_AGENT_KEY = "/external/v1/deleteagentcred";

/***** Xcelerator end points ******/
export const GET_XCELERATOR_DATA = "/agent/xcelerator/";

/***** Resend end points ******/
export const RESEND_INVITATION_KEY = "/user/auth/resend-invitation";

/***** Account activation end points ******/
// Set the password for an invited-but-not-onboarded account and activate it.
// PUT, with the record id appended to the URL.
export const ACTIVATE_CUSTOMER = "/customer/activate/";
export const ACTIVATE_SALES_REP = "/customer/salesrep/activate/";
export const ACTIVATE_AGENT = "/customer/agent/activate/";

/***** Invoice End Points ******/
export const GET_SAVE_CUSTOMER_INVOICE_GROUPS_LIST = "/order/invoice-group";

export const GET_SAVE_ORDER_INVOICE_LIST = "/order/invoice";
export const GET_ORDER_INVOICE_ORDER_DATA = "/order/invoice/group-orders";
export const GET_ORDER_INVOICE_CALCULATION_DATA = "/order/invoice/calc";
export const GET_ALL_INVOICE_GROUP = "/order/invoice/allInvoiceGroup";
// History endpoints used by the invoice listing "Mail History" action.
// The invoice id is appended by the modal (`${apiUrl}/${id}`).
export const GET_INVOICE_EMAIL_HISTORY = "/order/invoice/email-history";
export const GET_INVOICE_EDI_HISTORY = "/order/invoice/email-history";

/***** Resend end points ******/
export const DASHBOARD_API = "/order/dashboard/kpis";

/***** Agent api end points ******/
export const ADD_LOGIN_DETAILS = "agent/clientCredential/loginCredential";
export const GET_AGENT_API_DETAILS = "agent/clientCredential/agentcredlist";
export const UPDATE_LOGIN_DETAILS = "/agent/clientCredential/updateAgentCred/";
export const AGENT_REQUEST_API = "/agent/agent-request";
export const AGENT_REQUEST_PERMISSION_API = "/agent/agent-request/permission";

/***** System configuration end points ******/
//#SERVICES_ENDPOINT
export const ADD_SERVICES = "/service/addNewService";
export const UPDATE_SERVICES = "/service/updateService/";
export const GET_SERVICES = "/service";

export const ADD_PACKAGE_TYPE = "service/packagetype/create";
export const UPDATE_PACKAGE_TYPE = "/service/packagetype/update/";

/***** Import end points ******/
export const IMPORT_ZIP = "import/zip";
export const IMPORT_ACTIVE_CUSTOMER = "import/hubactivecustomer";
export const IMPORT_AGENT_HUB = "import/agentHub";
export const IMPORT_AGENT = "import/agent";
export const IMPORT_MILE_ZONE = "import/hubmilezone";
export const IMPORT_WEIGHT_ZONE = "import/hubweightzone";
export const IMPORT_FSC_AGENT = "import/fscagentlist ";
export const IMPORT_FSC_AGENT_INTERNAL_LTL = "/import/fscagentlist/internaltl";
export const IMPORT_AGENT_RATE = "import/agentrateimport";
export const IMPORT_CUSTOMER_LIST = "/import/customer/";
export const IMPORT_CUSTOMER_RATE_LIST = "/import/customer-rate/";
export const IMPORT_CUSTOMER_FSC_LIST = "/import/fsccustomer/";
export const IMPORT_AGENT_ADDITIONAL_CHARGES =
  "/import/additionalcharges/agent";
export const IMPORT_CUSTOMER_ADDITIONAL_CHARGES =
  "/import/additionalcharges/customer";
export const IMPORT_SCAC = "/import/bulkscac";
export const DOWNLOAD_IMPORT_TEMPLATE = "/import/download-template";
/***** Phone Validation Api ******/
export const PHONE_VALIDATE_API = "/order/phone-validate";

/***** Saved Quotation Api ******/
export const SAVE_QUOTATION = "/order/order-quote/savedquotation";
export const GET_QUOTATION = "/order/order-quote/savequotationlist";
export const DELETE_QUOTATION = "/order/order-quote/deletesavedquotation";
export const SAVE_LTL_QUOTATION = "/order/order-quote/savedquotationforltl";

/***** Email Template Api ******/
export const ADD_EMAIL_TEMPLATE = "/service/emailTemplate/create";
export const GET_EMAIL_TEMPLATE_DETAILS = "/service/emailTemplate/getById";
export const UPDATE_EMAIL_TEMPLATE = "/service/emailTemplate/update";

/***** Static Data Api ******/
export const STATIC_DATA_API = "/user/static/data";
/***** Email Template Api ******/
export const INVOICE_DETAIL_EDIT = "/customer/invoiceedidetail/";

/**Bulk Upload Quote end point */
export const UPLOAD_BULK_QUOTE = "import/bulkquote/";
/**Bulk Quote Listing end point */
export const BULK_QUOTE_LISTING = "import/bulkquote/list?limit=2&page=2";
/**Bulk Upload Order end point */
export const UPLOAD_BULK_ORDER = "import/bulkorder/";

//**Customer agent hubs Active and inactive agent hub API */
export const GET_AGENT_HUB_FOR_CUSTOMER = "customer/agenthub?page=1&limit=100";

//**Customer active hubs active and inactive save API endpoint */

export const SAVE_INACTIVE_ACTIVE_HUBS = "customer/agenthub/active";

//**Customer LTL integrations GET  reuest for Listing of APIs */
export const LTL_API_KEY_LIST = "/order/ltlApikey/apiKeyList";

// ** agent and customer listing API
export const CUSTOMER_LIST_FOR_HUB = "/customer/customerlistforhub";
export const GET_INVOICE_GROUP_CUSTOMERS = "/customer/invoice-group-customers";

/***** Master Zip Code end points ******/
export const GET_MASTER_ZIP_CODE_LIST = "/service/master-zipcode";
export const ADD_MASTER_ZIP_CODE = "/service/master-zipcode/create";
export const UPDATE_MASTER_ZIP_CODE = "/service/master-zipcode/update/";
export const DELETE_MASTER_ZIP_CODE = "/service/master-zipcode/delete/";
export const BULK_DELETE_MASTER_ZIP_CODE = "/service/master-zipcode/delete";
export const IMPORT_MASTER_ZIP_CODE = "/import/masterservicezipcode";


/***** Rep Management (My Rep List) end points ******/
export const GET_REP_LIST = "/customer/salesrep/";
export const REP_DETAIL = "/customer/salesrep/"; // trailing slash — rep id appended for delete/active
export const ADD_REP = "/customer/salesrep";
export const ACTIVE_REP = "/customer/salesrep/active/"; // trailing slash — rep id appended
export const EDIT_REP = "/customer/salesrep/"; // trailing slash — rep id appended
export const GET_REP_BY_ID = "/customer/salesrep/"; // trailing slash — rep id appended
export const SALES_REP_EMAIL_EXIST = "/customer/salesrep/email-exist"; // ?email= → { exist: boolean }
export const GET_SALES_REP_MASTER = "/customer/salesrepmaster"; // combined rep types + commission structures + triggers
export const GET_REP_TYPES = "/customer/salesrepmaster/reptype";
export const GET_SALES_REP_CUSTOMERS = "/customer/salesrepmaster/getAllCustomerListForSalesRep";
export const GET_COMMISSION_STRUCTURES = "/customer/salesrepmaster/commissionStructure";
export const GET_COMMISSION_TRIGGERS = "/customer/salesrepmaster/commissionTrigger";
export const EXPORT_REPS = "/import/sales-rep/export";


// Location Endpoints
export const ADD_LOCATION_MAPPING = "/order/location-mapping";
export const GET_LOCATION_LISTING = "/order/location-mapping/tenant-location";
export const DELETE_LOCATION_MAPPING = "/order/location-mapping/"

// Audit Log Endpoints
export const GET_AUDIT_LOG_LIST = "/order/activity-log";

export const ADD_CC_EMAIL = "/service/communication-email/add"


// Region endpoints
export const ADD_REGION_ENDPOINTS = "/service/region/create"
export const UPDATE_REGION_ENDPOINTS = "/service/region/update/"
export const GET_REGION_LISTING = "/service/region"
export const GET_STATE_LISTING = "/service/region/states"
export const DELETE_REGION_ENDPOINT = "/service/region/delete/"

// FSC Location endpoints
export const GET_FSC_LOCATION_CONFIG = "/service/fsc-location"
export const UPDATE_FSC_LOCATION_PRICE = "/service/fsc-location/update"


// Export Endpoints
export const EXPORT_ORDERS = "/import/order/export"
export const EXPORT_INVOICE = "/import/invoice/export"
export const EXPORT_AGENTS = "/import/agent/export"
export const EXPORT_MASTER_AGENTS = "/import/master-agent/export"
export const EXPORT_CUSTOMERS = "/import/customer/export"
export const EXPORT_CUSTOMER_USERS = "/import/customer-user/export"
export const EXPORT_CUSTOMER_ITEMS = "/import/customer-item/export"
export const EXPORT_ADDRESS_BOOK = "/import/address-book/export"
export const EXPORT_SITE_USERS ="/import/site-user/export"
export const EXPORT_CUSTOMER_GROUPS="/import/customer-invoice-group/export"

// Order Status Endpoints
export const GET_STATUS_ENDPOINT = "/service/order-status/"
export const UPDATE_STATUS_ENDPOINT = "/service/order-status/update/"

// Customer Onward Api endpoints
export const UPDATE_ONWARD_API_DETAILS = "/customer/onwardapidetail/"

// Order Tracking endpoints
export const ORDER_TRACKING_SEARCH = "/order/order-tracking/trackingOrderStatusAccordingtoSelectedKey"
export const ORDER_TRACKING_DETAILS = "/order/order-tracking/"

// Accounting exception audit-log endpoint (append orderId + ?page&limit)
export const GET_ACCOUNTING_EXCEPTION_AUDIT_LOG = "/order/accounting-exception/audit-log/"
// View Exception (banner) single-table audit log — append orderId.
export const GET_VIEW_EXCEPTION_AUDIT_LOG = "/order/accounting-exception/accounting-exception-audit-log/"

// SCAC endpoints
export const GET_SCAC_LTL_CARRIER = "/service/scac/ltlCarrier"